<template>
    <div class="phone-input-container">
        <div class="input-wrapper" :class="[{focus: isFocused}, {'input-error': errorMessage}, {'info-text': infoMessage} , {required}]">
            <vue-tel-input
                :value="value"
                @input="onInput"
                @validate="onValidate"
                :default-country="defaultCountry"
                :valid-characters-only="true"
                :mode="mode"
                :input-options="{autocomplete: 'off', name: name, autofocus: false, placeholder: placeholder, required: required}"
                :preferred-countries="preferredCountries"
            >
            </vue-tel-input>
            <svg class="error-icon" v-if="errorMessage.length" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="#C20202" d="M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"/>
            </svg>
            <p v-if="errorMessage.length" class="error-message">{{ errorMessage }}</p>
            <p v-if="infoMessage.length" class="info-message">{{ infoMessage }}</p>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Model } from 'vue-property-decorator';

const VueTelInput = () => Promise.all([
    import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
]).then(([{ VueTelInput }]) => VueTelInput);

@Component({
    components: {
        VueTelInput,
    },
})
export default class PhoneInput extends Vue
{
    @Model('input', {type: String})         readonly value!: string;
    @Prop(String)                           readonly label!: string;
    @Prop(String)                           readonly name!: string;
    @Prop(String)                           readonly mode!: string;
    @Prop(String)                           readonly placeholder!: string;
    @Prop(String)                           readonly defaultCountry!: string;
    @Prop(Array) 					   		readonly preferredCountries!: [];
    @Prop({type: String, default: ''})      readonly errorMessage!: string;
    @Prop({type: String, default: ''})      readonly infoMessage!: string;
    @Prop({type: Boolean, default: false})  readonly required!: boolean;

    isFocused: boolean = false;

    @Emit('focus')
    public setFocus() {
        this.isFocused = true;
    }

    @Emit('blur')
    public setBlur() {
        this.isFocused = false;
    }

    onValidate(phoneObject: any) {
        this.$emit('validate', phoneObject);
    }

    onInput(number: string) {
        this.$emit('change', number);
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';
@import 'vue-tel-input/dist/vue-tel-input.css';
.phone-input-container {
    font-family: $body-font-family;
    color: $body-font-color;
    font-size: $body-font-size;
    position: relative;

    .error-message {
        font-size: .7rem;
        margin-left: 12px;
        margin-top: 5px;
        color: var(--alert);
        margin-bottom: 10px;
    }

    .info-message {
        font-size: .7rem;
        margin-left: 12px;
        margin-top: 5px;
        color: var(--battleship-gray);
        margin-bottom: 0;
    }

    svg.error-icon {
        position: absolute;
        top: 13px;
        right: 8px;
        width: 24px;

        path {
            fill: var(--alert);
        }
    }

    .input-error {
        .vue-tel-input {
            margin-bottom: 0;
            border: 2px solid var(--alert) !important;

            .vti__dropdown {
                padding-left: 6px; // prevent content from shifting with borders
            }

            &:focus-within {
                border: 2px solid var(--alert) !important;
            }
        }
    }

    .vue-tel-input {
        height: 56px;
        border: 1px solid var(--medium-gray);
        border-radius: var(--global-radius) !important;
        box-sizing: border-box;
        margin-bottom: 22px; //keep space for error message
        transition: border-color ease 0.3s;

        &:focus-within {
            outline: 0;
            box-shadow: none !important;
            border: 2px solid var(--primary) !important;

            .vti__dropdown {
                padding-left: 6px; // prevent content from shifting with borders
            }
        }

        .vti__dropdown {
            border-top-left-radius: var(--global-radius);
            border-bottom-left-radius: var(--global-radius);

            &:focus {
                outline: 0;
            }
        }

        .vti__input {
            height: 100%;
            margin: 0;
            border: 0;
            border-top-right-radius: var(--global-radius);
            border-bottom-right-radius: var(--global-radius);
            box-shadow: none;

            &::placeholder {
                color: var(--battleship-gray);
            }

            &:focus {
                border: 0;
                outline: 0;
                box-shadow: none;
            }

        }
    }
}
</style>
